import {
  Autocomplete,
  CircularProgress,
  TextField,
  TextFieldProps,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { IdNameModel } from "services/KnowfullyAdminClient";

type SelectNotificationTriggerProps = {
  value: string | undefined;
  onChange: (id: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  textFieldProps?: Partial<TextFieldProps>;
};

const SelectNotificationTrigger = ({
  value,
  onChange,
  label,
  disabled,
  required,
  error,
  textFieldProps,
}: SelectNotificationTriggerProps) => {
  const { formatMessage: t } = useIntl();
  const { notificationsConfigurationsService } = useGlobalContext();

  const { data, isLoading } = useQuery(
    ["notificationsConfigurationsService.getNotificationJobEvents"],
    () => notificationsConfigurationsService.getNotificationJobEvents(),
  );

  const options = data?.data ?? [];
  const selectedValue = options.find((o) => o.id === value) ?? null;

  return (
    <Autocomplete
      autoComplete
      loading={isLoading}
      disabled={disabled || isLoading}
      options={options}
      value={selectedValue}
      getOptionLabel={(option) => (option as IdNameModel).name || ""}
      isOptionEqualToValue={(option, val) =>
        option.id === (val as IdNameModel).id
      }
      onChange={(_event, newValue) => {
        onChange((newValue as IdNameModel | null)?.id ?? "");
      }}
      renderInput={(input) => (
        <TextField
          variant="standard"
          {...textFieldProps}
          {...input}
          label={label || t({ id: "trigger" })}
          required={required}
          error={error}
          InputProps={{
            ...textFieldProps?.InputProps,
            ...input.InputProps,
            startAdornment: isLoading && <CircularProgress size={16} />,
          }}
          fullWidth
        />
      )}
    />
  );
};

export default SelectNotificationTrigger;
